// src/utils/reporteGastosGenerator.js

// 👈 NUEVO: Importar función que obtiene los datos de la empresa actual
import { obtenerDatosEmpresa } from './tenantConfig';

// Configuración por defecto (fallback)
const SYSTEM_JJ_CONFIG = {
  nombre: 'SYSTEM JJ',
  rif: 'J-41023119-0',
  slogan: 'Soluciones Tecnológicas',
  direccion: 'CALLE 30, CON AV. 33, C.C LATIN CENTER, LOCAL 01',
  ciudad: 'ACARIGUA, EDO. PORTUGUESA',
  telefono: '04145146450 / 5516151 / 02556223297',
  email: 'SOPORTE@SYSTEMJJ.COM',
  sitioWeb: 'www.systemjj.com'
};

/**
 * 👈 NUEVO: Obtiene la config de la empresa actual con fallback
 */
const getEmpresa = () => {
  try {
    const datos = obtenerDatosEmpresa();
    return {
      nombre: datos.nombreComercial || datos.nombre || SYSTEM_JJ_CONFIG.nombre,
      rif: datos.rif || SYSTEM_JJ_CONFIG.rif,
      slogan: datos.slogan || SYSTEM_JJ_CONFIG.slogan,
      direccion: datos.direccion || SYSTEM_JJ_CONFIG.direccion,
      ciudad: datos.ciudad || SYSTEM_JJ_CONFIG.ciudad,
      telefono: datos.telefono1 || datos.telefono2 || SYSTEM_JJ_CONFIG.telefono,
      email: datos.email || SYSTEM_JJ_CONFIG.email,
      sitioWeb: datos.sitioWeb || SYSTEM_JJ_CONFIG.sitioWeb,
      logoBase64: datos.logoBase64 || null,
    };
  } catch (err) {
    console.warn('⚠️ No se pudo obtener config del tenant, usando fallback:', err);
    return { ...SYSTEM_JJ_CONFIG, logoBase64: null };
  }
};

// ============================================================
// UTILIDADES LOCALES (antes venían de reporteProductosGenerator)
// ============================================================

const formatearFechaReporte = (fechaISO) => {
  if (!fechaISO) return 'No disponible';
  try {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-VE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return fechaISO;
  }
};

const formatearMonedaUSD = (valor) => {
  if (valor === null || valor === undefined || isNaN(valor)) return '$ 0,00';
  return `$ ${Number(valor).toFixed(2).replace('.', ',')}`;
};

// ============================================================
// IMPRIMIR REPORTE DE GASTOS (HTML)
// ============================================================

export const imprimirReporteGastos = async (gastos, tipo = 'dia') => {
  if (!gastos || gastos.length === 0) {
    alert('No hay gastos para mostrar');
    return false;
  }

  const empresa = getEmpresa();   // 👈 NUEVO: datos dinámicos del tenant

  const titulos = {
    dia: 'REPORTE DE GASTOS DEL DÍA',
    semana: 'REPORTE DE GASTOS DE LA SEMANA',
    mes: 'REPORTE DE GASTOS DEL MES'
  };

  const total = gastos.reduce((sum, g) => sum + (g.total || 0), 0);
  const fechaActual = new Date();

  const html = `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <title>Reporte de Gastos - ${empresa.nombre}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body {
      font-family: 'Arial', 'Helvetica', sans-serif;
      background: white;
      padding: 15px;
    }
    .reporte { max-width: 1200px; margin: 0 auto; }
    
    .header {
      padding: 10px 0;
      border-bottom: 1px solid #000;
      margin-bottom: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .logo-area { display: flex; align-items: center; gap: 10px; }
    .logo-img { height: 45px; width: auto; object-fit: contain; }
    .empresa-nombre { font-size: 16px; font-weight: bold; }
    .empresa-slogan { font-size: 9px; color: #666; }
    .rif-info { text-align: right; font-size: 9px; line-height: 1.3; }
    
    .titulo { padding: 8px 0; }
    .titulo h1 { font-size: 16px; font-weight: bold; }
    .fecha { font-size: 9px; color: #666; margin-top: 3px; }
    
    .stats-bar {
      background: #f8f8f8;
      padding: 6px 12px;
      margin: 10px 0;
      border: 1px solid #e0e0e0;
      font-size: 11px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 15px;
    }
    .stat-item-compact {
      display: inline-flex;
      align-items: baseline;
      gap: 4px;
    }
    .stat-label-compact {
      font-weight: normal;
      color: #666;
    }
    .stat-valor-compact {
      font-weight: bold;
      color: #000;
    }
    
    .tabla-container { overflow-x: auto; }
    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 9px;
      border: 1px solid #ddd;
    }
    th {
      background: #f5f5f5;
      padding: 6px 4px;
      text-align: left;
      font-weight: bold;
      border-bottom: 1px solid #ddd;
    }
    td {
      padding: 5px 4px;
      border-bottom: 1px solid #eee;
    }
    tr:hover td { background: #fafafa; }
    .text-center { text-align: center; }
    .text-right { text-align: right; }
    .font-bold { font-weight: bold; }
    .text-red { color: #dc2626; }
    
    .controles {
      text-align: center;
      margin-top: 15px;
      padding: 10px;
      background: #f5f5f5;
    }
    button {
      padding: 6px 15px;
      font-size: 10px;
      margin: 0 3px;
      cursor: pointer;
      border: 1px solid #ccc;
      background: white;
    }
    button:hover { background: #f0f0f0; }
    
    @media print {
      body { padding: 0; }
      .controles { display: none; }
      @page { margin: 1cm; size: landscape; }
    }
  </style>
</head>
<body>
<div class="reporte">
  <div class="header">
    <div class="logo-area">
      ${empresa.logoBase64 ? `<img src="${empresa.logoBase64}" class="logo-img" onerror="this.style.display='none'">` : ''}
      <div>
        <div class="empresa-nombre">${empresa.nombre}</div>
        <div class="empresa-slogan">${empresa.slogan}</div>
      </div>
    </div>
    <div class="rif-info">
      RIF: ${empresa.rif}<br>
      ${empresa.ciudad}
    </div>
  </div>
  
  <div class="titulo">
    <h1>${titulos[tipo] || 'REPORTE DE GASTOS'}</h1>
    <div class="fecha">${formatearFechaReporte(fechaActual.toISOString())}</div>
  </div>
  
  <div class="stats-bar">
    <div class="stat-item-compact"><span class="stat-label-compact">Total Gastos:</span><span class="stat-valor-compact">${formatearMonedaUSD(total)}</span></div>
    <div class="stat-item-compact"><span class="stat-label-compact">Registros:</span><span class="stat-valor-compact">${gastos.length}</span></div>
  </div>
  
  <div class="tabla-container">
    <table>
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Categoría</th>
          <th class="text-right">Precio</th>
          <th class="text-center">Cant.</th>
          <th class="text-right">Total</th>
          <th>Proveedor</th>
          <th>Fecha</th>
        </tr>
      </thead>
      <tbody>
        ${gastos.map(g => `
          <tr>
            <td><strong>${g.nombre || '—'}</strong></td>
            <td>${g.categoriaGasto || '—'}</td>
            <td class="text-right">${formatearMonedaUSD(g.precio)}</td>
            <td class="text-center">${g.cantidad || 1}</td>
            <td class="text-right font-bold text-red">${formatearMonedaUSD(g.total)}</td>
            <td>${g.proveedor || '—'}</td>
            <td>${new Date(g.fechaGasto).toLocaleDateString('es-VE')}</td>
          </tr>
        `).join('')}
      </tbody>
      <tfoot>
        <tr>
          <td colspan="4" class="text-right font-bold">TOTAL:</td>
          <td class="text-right font-bold text-red">${formatearMonedaUSD(total)}</td>
          <td colspan="2"></td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>

<div class="controles">
  <button onclick="window.print()">🖨️ IMPRIMIR</button>
  <button onclick="window.close()">✖️ CERRAR</button>
</div>
</body>
</html>`;

  const ventana = window.open('', '_blank', 'width=1100,height=700,menubar=yes,toolbar=yes,scrollbars=yes');
  if (!ventana) {
    alert('Por favor, permite ventanas emergentes');
    return false;
  }

  ventana.document.write(html);
  ventana.document.close();
  ventana.focus();
  return true;
};

// ============================================================
// EXPORTAR A EXCEL
// ============================================================

export const exportarGastosExcel = (gastos) => {
  try {
    if (typeof window === 'undefined') return false;
    const XLSX = require('xlsx');
    const wb = XLSX.utils.book_new();

    const data = gastos.map(g => ({
      'Nombre': g.nombre || '',
      'Categoría': g.categoriaGasto || '',
      'Descripción': g.descripcion || '',
      'Precio ($)': g.precio || 0,
      'Cantidad': g.cantidad || 1,
      'Total ($)': g.total || 0,
      'Proveedor': g.proveedor || '',
      'Método de Pago': g.metodoPago || '',
      'Referencia': g.referencia || '',
      'Fecha': g.fechaGasto ? new Date(g.fechaGasto).toLocaleDateString('es-VE') : '',
      'Estado': g.estado || 'pagado'
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    ws['!cols'] = [
      { wch: 30 }, { wch: 25 }, { wch: 40 }, { wch: 12 },
      { wch: 10 }, { wch: 12 }, { wch: 30 }, { wch: 20 },
      { wch: 15 }, { wch: 15 }, { wch: 12 }
    ];

    XLSX.utils.book_append_sheet(wb, ws, 'Gastos');

    const fecha = new Date().toISOString().split('T')[0];
    const nombreArchivo = `reporte_gastos_${fecha}.xlsx`;
    XLSX.writeFile(wb, nombreArchivo);

    return { success: true, filename: nombreArchivo, count: gastos.length };
  } catch (error) {
    console.error('Error exportando Excel:', error);
    return { success: false, error: error.message };
  }
};

// ============================================================
// EXPORTAR A PDF
// ============================================================

export const exportarGastosPDF = (gastos) => {
  try {
    if (typeof window === 'undefined') return false;
    const empresa = getEmpresa();   // 👈 NUEVO: datos dinámicos del tenant

    const { jsPDF } = require('jspdf');
    require('jspdf-autotable');

    const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
    const pageWidth = doc.internal.pageSize.width;

    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text(`REPORTE DE GASTOS - ${empresa.nombre}`, pageWidth / 2, 12, { align: 'center' });

    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.text(`Generado: ${new Date().toLocaleDateString('es-VE')}`, pageWidth / 2, 18, { align: 'center' });

    const total = gastos.reduce((sum, g) => sum + (g.total || 0), 0);
    doc.setFontSize(7);
    doc.text(`Total Gastos: $${total.toFixed(2)} | Registros: ${gastos.length}`, 14, 24);

    const tableData = gastos.map(g => [
      (g.nombre || '').substring(0, 25),
      g.categoriaGasto || '',
      `$${Number(g.precio || 0).toFixed(2)}`,
      g.cantidad || 1,
      `$${Number(g.total || 0).toFixed(2)}`,
      (g.proveedor || '').substring(0, 20),
      g.fechaGasto ? new Date(g.fechaGasto).toLocaleDateString('es-VE') : ''
    ]);

    doc.autoTable({
      startY: 28,
      head: [['Nombre', 'Categoría', 'Precio', 'Cant.', 'Total', 'Proveedor', 'Fecha']],
      body: tableData,
      theme: 'striped',
      headStyles: { fillColor: [100, 100, 100], textColor: 255, fontSize: 7 },
      styles: { fontSize: 6, cellPadding: 1.5 },
      columnStyles: {
        0: { cellWidth: 35 },
        1: { cellWidth: 25 },
        2: { cellWidth: 15 },
        3: { cellWidth: 10 },
        4: { cellWidth: 18 },
        5: { cellWidth: 25 },
        6: { cellWidth: 18 }
      },
      margin: { top: 28 },
      didDrawPage: function (data) {
        doc.setFontSize(6);
        doc.text(`Página ${data.pageNumber}`, pageWidth / 2, doc.internal.pageSize.height - 8, { align: 'center' });
      }
    });

    const nombreArchivo = `reporte_gastos_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(nombreArchivo);

    return { success: true, filename: nombreArchivo, count: gastos.length };
  } catch (error) {
    console.error('Error exportando PDF:', error);
    return { success: false, error: error.message };
  }
};

export default {
  imprimirReporteGastos,
  exportarGastosExcel,
  exportarGastosPDF
};